export const METRIC_NAME = 'web.custom_metrics';
/**
 * Default transport for metrics, which logs to the console that
 * gets picked up by the Datadog agent.
 * @param metricName - The name of the metric
 * @param duration - The duration of the metric
 * @param extra - Extra labels for the metric
 */
export function defaultTransport(metricName, duration, extra) {
    console.info(METRIC_NAME, {
        metricName,
        duration,
        ...extra,
    });
}
/**
 * Start a timer for a metric
 * @param extra - Extra labels for the metric
 * @param config - Configuration for the timer
 * @returns A timer object
 */
export function startTimer(extra = {}, { transport = defaultTransport, nowFromTimeOrigin = performance.now(), getTimeOrigin = () => performance.timeOrigin, } = {}) {
    const globalContext = { ...extra };
    const onceEvents = new Set();
    const events = [];
    function addTiming(metricName, moreExtra = {}) {
        // This is in milliseconds
        const now = performance.now();
        const duration = now - nowFromTimeOrigin;
        const event = {
            metricName,
            duration,
            absoluteTime: now + getTimeOrigin(),
        };
        events.push(event);
        transport(metricName, duration, {
            ...globalContext,
            ...moreExtra,
            // Store the start time of the timer
            startTime: nowFromTimeOrigin + getTimeOrigin(),
        });
        return event;
    }
    function addTimingOnce(metricName, moreExtra) {
        if (onceEvents.has(metricName)) {
            return events.find((event) => event.metricName === metricName);
        }
        onceEvents.add(metricName);
        return addTiming(metricName, moreExtra);
    }
    return {
        addTimingOnce,
        addTiming,
        getEvents() {
            return events;
        },
        setGlobalContext(context) {
            Object.assign(globalContext, context);
        },
        getStartTimeFromTimeOrigin() {
            return nowFromTimeOrigin;
        },
        getAbsoluteStartTime() {
            return nowFromTimeOrigin + getTimeOrigin();
        },
    };
}
//# sourceMappingURL=core.js.map